<style lang="scss">
    .cart-table-remove-item {
        color: #cd6c6c;
        cursor: pointer;
    }
    .collection-remove-item{
        margin-left: 25px;
    }
    .checkout-items{
        .section-title{
            font-family: Poppins !important;
            font-size: 20px !important;
            border-bottom: 1px solid rgba(200, 200, 200, 0.4);
            opacity: 0.36;
            font-weight: 500 !important;
            margin-bottom: 0px !important;
            line-height: 40px !important;
            margin-top: 10px !important;
        }
    }
</style>

<template>
<div class="checkout-items">
    <!-- beats start-->
    <div v-if="beats.length > 0">
        <h3 class="section-title" :style="$customBorderColor(0.3)">Beats</h3>
        <item-container :cartPopup="cartPopup" v-for="beat in beats" :element="beat" :key="beat.item.id"></item-container>
    </div>
    <!-- beats end -->
    <!-- sound packs start -->
    <div v-if="kits.length > 0">
        <h3 class="section-title" :style="$customBorderColor(0.3)">Sound Packs</h3>
        <item-container :cartPopup="cartPopup" v-for="kit in kits" :element="kit" :key="kit.item.id"></item-container>
	</div>
    <!-- sound packs end -->
    <!-- songs start -->
    <div v-if="songs.length > 0">
        <h3 class="section-title" :style="$customBorderColor(0.3)">Songs</h3>
        <item-container :cartPopup="cartPopup" v-for="song in songs" :element="song" :key="song.item.id"></item-container>
    </div>
    <!-- songs end -->

    <!-- collections start -->
        <!--<div class="panel panel-default" v-for="item in collections" :key="item.item.id">-->
			<!--<div class="panel-heading">-->
				<!--<h3 class="panel-title">{{ item.item.name }}-->
                    <!--<div class="pull-right">-->
                        <!--<span >{{ item.price | displayPrice }}</span>-->
                        <!--<div @click="cart.removeItem(item)" class="collection-remove-item cart-table-remove-item pull-right" data-item-type="beat">-->
                            <!--<span class="remove-item-text">Remove</span>-->
                            <!--<i class="fa fa-times-circle-o"></i>-->
                        <!--</div>-->
                    <!--</div>-->
					<!---->
				<!--</h3>-->
			<!--</div>-->
			<!--<div class="panel-body p0">-->
				<!--<table class="table table-striped table-bordered">-->
					<!--<tbody>-->
					<!---->
						<!--<tr v-for="collectionItem in item.item.saleable.collection_items" :key="collectionItem.id">-->
							<!--<td>-->
								<!--{{ collectionItem.name }}<br>-->
								<!--<span class="label label-primary">{{ collectionItem.type }}</span>-->
							<!--</td>-->
							<!--<td class="text-right" v-if="collectionItem.license">-->
                                <!--{{collectionItem.license.name}}<br>-->
                                <!--<a data-toggle="modal" href="#license-terms" @click="-->
                                <!--setModalLicense(collectionItem.license.id)">License Terms</a>-->
							<!--</td>-->
                            <!--<td class="text-right" v-else>-->
								<!-- - -->
							<!--</td>-->
                            <!---->
						<!--</tr>-->
					<!--</tbody>-->
				<!--</table>-->
			<!--</div>-->
		<!--</div>-->
    <!-- collections end -->
</div>
</template>

<script>
    import CartItem from '../../classes/CartItem'
    import ItemContainer from './itemcontainer.vue'
    import Beat from '../../models/beat'
    import Kit from '../../models/soundkit'
    import Collection from '../../models/collection'
    import Song from '../../models/song'
    import Playlist from './../../classes/playlist';
    import SoundKit from '../../models/soundkit';
    import Configure from './../../mixins/configure'

    import Coupons from '../../mixins/coupons.vue'

    export default {
        props: {
            modal: {
                type: Boolean,
                default: false
            },
            cartPopup: {
                type: Boolean,
                default: false
            }
        },
        mixins: [
            Coupons, Configure
        ],
        components : {
            ItemContainer
        },
        data() {
            return {
                beats : {},
                songs : {},
                kits : {},
                collections : {},
                modalLicense: null,
            }
        },
        created() {
            this.build_cart(this.cart.cart)
        },
		computed: {
            cartItems(){
                return this.$store.state.cart.cart
            },
            cart(){
                return this.$store.state.cart
            },
            playlistManager() {
                return this.$store.state.playlistManager
            },
            coupon(){
                return this.$store.state.cart.coupon
            }
        },
        watch:{
			cartItems: function(newVal, oldVal) {
				 this.build_cart(newVal)
            },
            coupon: function(newVal, oldVal) {
				 this.build_cart(this.cartItems)
            }
		},
		methods: {
            findObjectByKey(array, key, value) {
                let result = [];
                for (var i = 0; i < array.length; i++) {
                    if (array[i][key] === value) {
                        result.push(array[i])
                    }
                }
                return result;
            },
            // method added because we dont have a transformer for the cart object
            // and no api to get cart with all details
            build_cart(items){

                this.beats = this.findObjectByKey(items , 'type' , 'beat')
                this.songs = this.findObjectByKey(items , 'type' , 'song')
                this.kits = this.findObjectByKey(items , 'type' , 'soundkit')
                //this.collections = this.findObjectByKey(items , 'type' , 'collection');

                if (!this.modal) {
                    let playlist = this.playlistManager.getPagePlaylist()

                    playlist.addPlaylistItems(this.beats.map(i => i.item))
                    playlist.addPlaylistItems(this.songs.map(i => i.item))
                    playlist.addPlaylistItems(this.kits.map(i => i.item))
                }

             },
            updateUrl(){
                let currentUrl = window.location.href
                let b64Cart = encodeURIComponent(this.cart.base64EncodedCart())
                let urlArray = currentUrl.split('&')
                urlArray[urlArray.length-1] = 'cart='+b64Cart
                let newUrl = urlArray.join('&')
                window.history.replaceState({},null,newUrl)
            },
        }
    }
</script>
